var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ffk-whats-new-sidebar-content"},[_c('iframe',{ref:"releaseNotesIframe",staticClass:"releaseNotesIframe",attrs:{"title":"Release notes frame","id":"releaseNotesIframe","width":"100%","height":_vm.iframeHeight,"src":_vm.documentationPath}})])
}
var staticRenderFns = []

export { render, staticRenderFns }